function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { makeStyles, Grid, Box, Typography, GRAY } from '@applyboard/ui-components';
import { EDUCATION_DISPLAY, BACKEND_TO_FRONTEND_MAP } from "./consts";
import EnglishTests from "../Tests/Mobile/EnglishTests";
import { ENGLISH_EXAM_INPUT_VALUES } from "../../../../EnglishTests/consts";
import StandardTests from "../Tests/Mobile/StandardTests";
import StudentScore from "../Tests/Mobile/components/StudentScore";
import { AcceptedTestsTooltip } from "../Tooltips";
import ConditionalAcceptanceInfo from "../../../../ConditionalAcceptanceInfo";
import { VisitorStudentLanguage } from "../../../../../Utilities/LanguageHelper";
var useStyles = makeStyles({
  header: {
    textTransform: 'uppercase',
    color: GRAY[10]
  },
  requirement: {
    color: GRAY[10]
  },
  user: {
    textAlign: 'right'
  },
  icon_container: {
    textAlign: 'right'
  },
  icon: {
    position: 'relative',
    paddingLeft: '14px',
    paddingRight: '8px',
    bottom: '2px'
  },
  row: {
    borderTop: "1px solid ".concat(GRAY[18]),
    padding: '8px 0'
  }
});
var prepareForDisplay = function prepareForDisplay(result, student) {
  var _student$gmat, _student$gre;
  var criteria = result.criteria,
    elpInfoHack = result.elp_info_hack;
  var education = {
    level: {
      req: criteria.education_level.requires,
      student: criteria.education_level.applicant_has,
      pass: criteria.education_level.requirement_met
    },
    gpa: {
      req: criteria.gpa.requires,
      student: criteria.gpa.applicant_has,
      pass: criteria.gpa.requirement_met
    }
  };
  var englishTests = getEnglishTestDisplay(student.eng_test, elpInfoHack);
  var showGRE = Boolean(criteria.gre);
  var showGMAT = Boolean(criteria.gmat);
  var showStandardTests = showGRE || showGMAT;
  var standard_tests_to_display = {
    selected: [],
    accepted: [],
    showGRE: showGRE,
    showGMAT: showGMAT
  };
  if (criteria.gre) {
    standard_tests_to_display.accepted.push('gre');
    standard_tests_to_display.gre = {
      q: {
        req: criteria.gre.sub_scores.quantitative.requires,
        student: criteria.gre.sub_scores.quantitative.applicant_has,
        pass: criteria.gre.sub_scores.quantitative.requirement_met
      },
      qp: {
        req: criteria.gre.sub_scores.quantitative_percentile.requires,
        student: criteria.gre.sub_scores.quantitative_percentile.applicant_has,
        pass: criteria.gre.sub_scores.quantitative_percentile.requirement_met
      },
      t: {
        req: criteria.gre.sub_scores.verbal_quantitative_combined.requires,
        student: criteria.gre.sub_scores.verbal_quantitative_combined.applicant_has,
        // if student has a score then set pass, else pass should be null
        pass: criteria.gre.sub_scores.verbal_quantitative_combined.applicant_has ? criteria.gre.sub_scores.verbal_quantitative_combined.requirement_met : null
      },
      v: {
        req: criteria.gre.sub_scores.verbal.requires,
        student: criteria.gre.sub_scores.verbal.applicant_has,
        pass: criteria.gre.sub_scores.verbal.requirement_met
      },
      vp: {
        req: criteria.gre.sub_scores.verbal_percentile.requires,
        student: criteria.gre.sub_scores.verbal_percentile.applicant_has,
        pass: criteria.gre.sub_scores.verbal_percentile.requirement_met
      },
      w: {
        req: criteria.gre.sub_scores.writing.requires,
        student: criteria.gre.sub_scores.writing.applicant_has,
        pass: criteria.gre.sub_scores.writing.requirement_met
      },
      wp: {
        req: criteria.gre.sub_scores.writing_percentile.requires,
        student: criteria.gre.sub_scores.writing_percentile.applicant_has,
        pass: criteria.gre.sub_scores.writing_percentile.requirement_met
      }
    };
  }
  if (criteria.gmat) {
    standard_tests_to_display.accepted.push('gmat');
    standard_tests_to_display.gmat = {
      q: {
        req: criteria.gmat.sub_scores.quantitative.requires,
        student: criteria.gmat.sub_scores.quantitative.applicant_has,
        pass: criteria.gmat.sub_scores.quantitative.requirement_met
      },
      qp: {
        req: criteria.gmat.sub_scores.quantitative_percentile.requires,
        student: criteria.gmat.sub_scores.quantitative_percentile.applicant_has,
        pass: criteria.gmat.sub_scores.quantitative_percentile.requirement_met
      },
      t: {
        req: criteria.gmat.sub_scores.total.requires,
        student: criteria.gmat.sub_scores.total.applicant_has,
        // if student has a score then set pass, else pass should be null
        pass: criteria.gmat.sub_scores.total.applicant_has ? criteria.gmat.sub_scores.total.requirement_met : null
      },
      tp: {
        req: criteria.gmat.sub_scores.total_percentile.requires,
        student: criteria.gmat.sub_scores.total_percentile.applicant_has,
        pass: criteria.gmat.sub_scores.total_percentile.requirement_met
      },
      v: {
        req: criteria.gmat.sub_scores.verbal.requires,
        student: criteria.gmat.sub_scores.verbal.applicant_has,
        pass: criteria.gmat.sub_scores.verbal.requirement_met
      },
      vp: {
        req: criteria.gmat.sub_scores.verbal_percentile.requires,
        student: criteria.gmat.sub_scores.verbal_percentile.applicant_has,
        pass: criteria.gmat.sub_scores.verbal_percentile.requirement_met
      },
      w: {
        req: criteria.gmat.sub_scores.writing.requires,
        student: criteria.gmat.sub_scores.writing.applicant_has,
        pass: criteria.gmat.sub_scores.writing.requirement_met
      },
      wp: {
        req: criteria.gmat.sub_scores.writing_percentile.requires,
        student: criteria.gmat.sub_scores.writing_percentile.applicant_has,
        pass: criteria.gmat.sub_scores.writing_percentile.requirement_met
      }
    };
  }
  if ((_student$gmat = student.gmat) !== null && _student$gmat !== void 0 && _student$gmat.value) standard_tests_to_display.selected.push('gmat');
  if ((_student$gre = student.gre) !== null && _student$gre !== void 0 && _student$gre.value) standard_tests_to_display.selected.push('gre');
  return {
    eng_tests_to_display: englishTests,
    standard_tests_to_display: standard_tests_to_display,
    education: education,
    showEngTests: !!elpInfoHack,
    showStandardTests: showStandardTests
  };
};
function getEnglishTestDisplay(englishTest, elpInfoHack) {
  if (!englishTest || !(elpInfoHack !== null && elpInfoHack !== void 0 && elpInfoHack.submitted_scores)) {
    return {
      accepted: [],
      selected: ''
    };
  }
  var submittedScores = elpInfoHack.submitted_scores,
    otherScores = elpInfoHack.other_scores;
  return _objectSpread(_objectSpread({
    accepted: [].concat(_toConsumableArray(submittedScores.accepted ? [submittedScores.type] : []), _toConsumableArray(otherScores.map(function (test) {
      return test.type;
    }))),
    selected: submittedScores.type
  }, getSubmittedTestDisplay(submittedScores, englishTest)), getOtherTestsDisplay(submittedScores, otherScores));
}
function getSubmittedTestDisplay(submittedScores, englishTest) {
  return _defineProperty({}, submittedScores.type, Object.fromEntries(Object.keys(englishTest).filter(function (key) {
    return ENGLISH_EXAM_INPUT_VALUES[submittedScores.type].has(key);
  }).map(function (key) {
    var backendScores = submittedScores.sub_scores;
    var frontendKey = BACKEND_TO_FRONTEND_MAP[key];
    return [frontendKey, {
      // @ts-expect-error -- this is complicated
      req: backendScores[key].requires,
      // @ts-expect-error -- this is complicated
      student: backendScores[key].applicant_has,
      // @ts-expect-error -- this is complicated
      pass: backendScores[key].requirement_met
    }];
  })));
}
function getOtherTestsDisplay(submittedScores, otherScores) {
  return Object.fromEntries(otherScores.map(function (score) {
    return [score.type, _objectSpread({
      accepted: true
    }, Object.fromEntries(Object.entries(score.sub_scores).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        _key = _ref3[0],
        value = _ref3[1];
      var key = _key;
      var isOverallScore = key === 'total' || key === 'average';
      var showMissing = isOverallScore && !submittedScores.accepted;
      // eligibility backend returns PTE overall score as 'average' but we use 'total' everywhere
      var frontendKey = score.type === 'pte' && key === 'average' ? 'total' : BACKEND_TO_FRONTEND_MAP[key];
      return [frontendKey, {
        req: value.requires,
        student: showMissing ? 'Missing' : null,
        pass: showMissing ? false : null
      }];
    })))];
  }));
}
var IneligibleDetails = function IneligibleDetails(_ref4) {
  var _result$criteria, _result$criteria$eng_, _education$gpa;
  var program = _ref4.program,
    result = _ref4.result,
    student = _ref4.student;
  var _prepareForDisplay = prepareForDisplay(result, student),
    eng_tests = _prepareForDisplay.eng_tests_to_display,
    standard_tests = _prepareForDisplay.standard_tests_to_display,
    education = _prepareForDisplay.education,
    showEngTests = _prepareForDisplay.showEngTests,
    showStandardTests = _prepareForDisplay.showStandardTests;
  var accepted = eng_tests.accepted;
  var showAcceptedTestsTooltip = accepted.length > 0;
  var classes = useStyles();
  var showEnglishPathwayHint = showEngTests && result.eligibility === 'ineligible' && ((_result$criteria = result.criteria) === null || _result$criteria === void 0 ? void 0 : (_result$criteria$eng_ = _result$criteria.eng_test) === null || _result$criteria$eng_ === void 0 ? void 0 : _result$criteria$eng_.eligibility) === 'conditional';
  return /*#__PURE__*/React.createElement(Box, {
    mt: "40px"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    xs: 12,
    style: {
      padding: '8px 0'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "section",
    className: classes.header
  }, "Requirement")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "section",
    className: "".concat(classes.header, " ").concat(classes.user)
  }, VisitorStudentLanguage.ResultsHeader))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row,
    style: {
      paddingTop: '8px'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.requirement
  }, "Education level")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    style: {
      color: GRAY[10]
    }
  }, EDUCATION_DISPLAY[education.level.req])), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(StudentScore, {
    pass: education.level.pass
  }, EDUCATION_DISPLAY[education.level.student]))))), (education === null || education === void 0 ? void 0 : (_education$gpa = education.gpa) === null || _education$gpa === void 0 ? void 0 : _education$gpa.req) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.requirement
  }, "GPA")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    style: {
      color: GRAY[10]
    }
  }, education.gpa.req)), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(StudentScore, {
    pass: education.gpa.pass,
    gpa: true
  }, education.gpa.student))))), showEngTests && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "English Tests", showAcceptedTestsTooltip && /*#__PURE__*/React.createElement(AcceptedTestsTooltip, null))), /*#__PURE__*/React.createElement(EnglishTests, {
    tests: eng_tests
  })), showStandardTests && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      paddingBottom: '12px'
    }
  }, "Standardized Tests")), /*#__PURE__*/React.createElement(StandardTests, {
    tests: standard_tests
  })), showEnglishPathwayHint && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "English test score too low?", '  ', /*#__PURE__*/React.createElement(ConditionalAcceptanceInfo, {
    buttonText: "Learn about our English pathway program.",
    modalText: program.conditionalAcceptanceText
  })))));
};
export default IneligibleDetails;